import layoutHeaderAside from '@/layout/header-aside';

const meta = { auth: true, title: '程序管理', checkAuth: true };

export default {
  path: '/codes',
  name: 'codes',
  meta,
  redirect: { name: 'codes-page1' },
  component: layoutHeaderAside,
  children: (pre => [
    { path: 'page1', name: `${pre}page1`, component: () => import('@/pages/codes/page1'), meta: { ...meta, title: '草稿管理' } },
    { path: 'page2', name: `${pre}page2`, component: () => import('@/pages/codes/page2'), meta: { ...meta, title: '模板管理' } }
  ])('codes-')
};
